import * as React from 'react';
import {  Mask } from "antd-mobile";
import { FC } from 'react';
import PageLoading from './PageLoading';
import styled from '@emotion/styled';

export interface Props {
  visible: boolean
}
const MaskLoading: FC<Props> = ({ visible }) => {
  return (
    <MaskStyle
      visible={visible}
      stopPropagation={['click']}
      opacity='thin'
    >
      <div style={{ height: '100%', width: '100%' }}>
        <PageLoading />
        <br />
        <p style={{ color: "white" }}>加载中...</p>
      </div>

    </MaskStyle>
  )
};
const MaskStyle = styled(Mask)`
  width: 100%;
  height: 100%;
  text-align: center;
`

export default MaskLoading;
